export default {"src":"/_next/static/media/right-arrw-link.76913490.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};